
    $(window).on('load',function(){
      $(function() {
          let url = location.href;
          var urloffset = 60;
          if(url.indexOf("?id=") != -1){
              let id = url.split("?id=");
              let $target = $('#' + id[id.length - 1]);
              if($target.length){
                  let position = $target.offset().top - urloffset;
                  $("html, body").animate({scrollTop:position}, 1);
              }
          }
      });
    })
    var window_h = $(window).height();
    $(window).on("load scroll", function() {
      var scroll_top = $(window).scrollTop();
      $(".js-fade,.js-n-fade,.js-l-fade,.js-r-fade,.js-u-fade").each(function() {
        //各box要素のtopの位置
        var elem_pos = $(this).offset().top;
        //タイミング
        if (scroll_top >= elem_pos - window_h + 50) {
          $(this).addClass("fade-in");
        }
      });
      $(".footPrints").each(function() {
        //各box要素のtopの位置
        var elem_pos = $(this).offset().top;
        //タイミング
        if (scroll_top >= elem_pos - window_h + 50) {
          $(this).addClass("active");
        }
      });
      $(".js-scale").each(function() {
        //各box要素のtopの位置
        var elem_pos = $(this).offset().top;
        //タイミング
        if (scroll_top >= elem_pos - window_h + 50) {
          $(this).addClass("scale-in");
        }
      });
      $(".js-fade-trigger").each(function() {
        //各box要素のtopの位置
        var elem_pos = $(this).offset().top;
        //タイミング
        if (scroll_top >= elem_pos - window_h + 50) {
          $(this).addClass("animated");
        }
      });
    });
    $(window).on("load", function() {
      $('.mv .js-n-fade').addClass("fade-in");
      $('.mv .js-scale').addClass("scale-in");
    });

$(function(){
  if (window.matchMedia( "(max-width: 767px)" ).matches) {
    var slider = $(".snsSlider").slick({
      infinite: true,
      swipe: true,
      autoplay: true,
      dots: false,
      arrows: true,
      slidesToShow:1,
      touchMove:false,
      autoplaySpeed: 4000,
      centerMode: true,
      centerPadding:"15%",
      // autoplaySpeed: 5000,
      // cssEase: 'linear',
      speed: 800,
      slidesToScroll: 1,
      pauseOnFocus: false,
      pauseOnHover: false,
      focusOnSelect: true,
    }); 
  }




  $('a[href^="#"]').click(function(){
    var headerHeight = $('#header').height();
    var speed = 500;
    var offset = 60;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - headerHeight;
    if (window.matchMedia( "(max-width: 768px)" ).matches) {
      var position = target.offset().top - headerHeight;
    } else{
      var position = target.offset().top - offset;
    }
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });

  if (window.matchMedia( "(max-width: 767px)" ).matches) {
    $(window).on('scroll', function (){
      var check = window.pageYOffset ;
      var docHeight = $(document).height();
      var dispHeight = $(window).height();
      if(check > docHeight-dispHeight-200){
          $('.linkBox').fadeOut(700);
      }else{
          $('.linkBox').fadeIn(700);
      }
    });
    }

    // if (window.matchMedia( "(min-width: 768px)" ).matches) {
    //   var startPos = 0,winScrollTop = 0;
    //   $(window).on('scroll',function(){
    //     winScrollTop = $(this).scrollTop();

    //     if (winScrollTop >= startPos) {
    //         $('#header').addClass('hide');
    //     } else {
    //         $('#header').removeClass('hide');
    //     }
    //     startPos = winScrollTop;
    //  });
    // }
});







$(".gnavi").on("click", function(){
    // ハンバーガーメニューの位置を設定
    var rightVal = 0;
    if($(this).hasClass("open")) {
        // メニューを開いたら次回クリック時は閉じた状態になるよう設定
        $(this).removeClass("open");
    } else {
        // メニューを開いたら次回クリック時は閉じた状態になるよう設定
        $(this).addClass("open");
    }
 });
